"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AadAppNameTooLongError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "AadAppNameTooLong";
const messageKey = "driver.aadApp.error.appNameTooLong";
class AadAppNameTooLongError extends teamsfx_api_1.UserError {
    constructor(actionName) {
        super({
            source: actionName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey),
        });
    }
}
exports.AadAppNameTooLongError = AadAppNameTooLongError;
//# sourceMappingURL=aadAppNameTooLongError.js.map